import styled from "@emotion/styled";
import CorpDeungiPackageListBox from "@src/components/corpDeungi/CorpDeungiPackageListBox";
import DeungiHeader from "@src/components/deungi/DeungiHeader";
import React from "react";
import { WebAppBridge } from "@src/lib/WebAppBridge";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CorpSearchListDto } from "@src/hooks/deungi/dto/SearchList.dto";
import { useCorpDeungiSubmit } from "@src/hooks/deungi/useDeungiSubmit";

const CorpDeungiPayment = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const inflow = searchParams.get("inflow");

    const submitDeungi = async (params: CorpSearchListDto) => {
        const res = await useCorpDeungiSubmit(params);
        const id: string = res.data._id;
        return id;
    };

    const handlePaymentSuccess = async () => {
        const selectedCorpState = localStorage.getItem("corpSelected");
        if (selectedCorpState) {
            const selectedCorp = JSON.parse(selectedCorpState);
            const id = await submitDeungi(selectedCorp);

            if (id) {
                localStorage.removeItem("corpSelected");
                localStorage.removeItem("corpSearchText");
                navigate({
                    pathname: "/corpDeungi",
                    search: `?type=search&watch=${id}`,
                });
            }
        }
    };

    WebAppBridge.onPaymentSuccess = () => {
        if (inflow) {
            handlePaymentSuccess();
        } else {
            navigate("/corpDeungi?type=search");
        }
    };

    return (
        <Container>
            <DeungiHeader title="충전하기" />
            <div className="box">
                <CorpDeungiPackageListBox />
            </div>
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    height: 100vh;
    height: calc(var(--vh, 1dvh) * 100);
    animation: fadeIn 0.5s forwards;
    background-color: white;

    .box {
        position: absolute;
        top: 56px;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        overflow: auto;
        overscroll-behavior-y: none;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

export default CorpDeungiPayment;
